import { PropertyType } from '../../../common';

export const mapEntityToApi = (data: PropertyType): PropertyType => ({
	sid: data.token,
	start_date: data.start_date,
	end_date: data.end_date,
});
